import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "AutoScroll"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12ZM13.5 12C13.5 12.8284 12.8284 13.5 12 13.5C11.1716 13.5 10.5 12.8284 10.5 12C10.5 11.1716 11.1716 10.5 12 10.5C12.8284 10.5 13.5 11.1716 13.5 12ZM12 20.3775L7.8 16.185L6.75 17.25L12 22.5L17.25 17.25L16.1925 16.1925L12 20.3775ZM12 3.6225L16.185 7.8L17.25 6.75L12 1.5L6.75 6.75L7.8075 7.8075L12 3.6225Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/AutoScroll.vue"]]);
